import React from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '../../lib/auth.context'
import { useMerchant } from '../../lib/hooks/useMerchant'

export function ProtectedRoute() {
  const { status, isBanned, bannedUntil, logout } = useAuth()
  const location = useLocation()
  const { merchantId, loading: merchantLoading } = useMerchant()

  if (status === 'loading') {
    return <div data-testid="loading-spinner">Loading...</div>
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  if (status === 'mfa_required') {
    if (location.pathname !== '/auth/mfa-verify') {
      return <Navigate to="/auth/mfa-verify" state={{ from: location }} replace />
    }
  }

  if (isBanned && bannedUntil) {
    const BannedUserMessage = React.lazy(() =>
      import('../admin/users/banned-user-message').then((m) => ({ default: m.BannedUserMessage })),
    )
    return (
      <React.Suspense fallback={<div>Loading...</div>}>
        <BannedUserMessage bannedUntil={bannedUntil} />
      </React.Suspense>
    )
  }

  // Wait for merchant identity check to complete
  if (merchantLoading) {
    return <div data-testid="loading-spinner">Loading...</div>
  }

  // Block non-merchant users from accessing the merchant portal
  if (!merchantId) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center space-y-4 p-8">
          <h1 className="text-2xl font-bold text-gray-900">Access Denied</h1>
          <p className="text-gray-600">
            This portal is for merchant accounts only. Your account does not have merchant access.
          </p>
          <button
            onClick={() => logout(true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 hover:bg-gray-700"
          >
            Sign Out
          </button>
        </div>
      </div>
    )
  }

  return <Outlet />
}
